import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { TechnologyItem } from "../../../../pages/hid-admin/dashboard/partner-settings/technology-management/types";
import type {
  IntegrationDetailUi,
  TechnologySettingsTechnologiesState,
} from "./Types";

const initialState: TechnologySettingsTechnologiesState = {
  technologies: [],
  integrationDetail: null,
  status: {
    technologiesLoading: false,
    createTechnologyLoading: false,
    updateTechnologyLoading: false,
    deleteTechnologyLoading: false,
    integrationDetailLoading: false,
    createIntegrationLoading: false,
    updateIntegrationLoading: false,
  },
};

const technologySettingsTechnologiesSlice = createSlice({
  name: "technology-settings-technologies",
  initialState,
  reducers: {
    setTechnologies: (state, action: PayloadAction<TechnologyItem[]>) => {
      state.technologies = action.payload;
    },
    setTechnologiesLoading: (state, action: PayloadAction<boolean>) => {
      state.status.technologiesLoading = action.payload;
    },
    setCreateTechnologyLoading: (state, action: PayloadAction<boolean>) => {
      state.status.createTechnologyLoading = action.payload;
    },
    setUpdateTechnologyLoading: (state, action: PayloadAction<boolean>) => {
      state.status.updateTechnologyLoading = action.payload;
    },
    setDeleteTechnologyLoading: (state, action: PayloadAction<boolean>) => {
      state.status.deleteTechnologyLoading = action.payload;
    },
    setIntegrationDetail: (
      state,
      action: PayloadAction<IntegrationDetailUi | null>
    ) => {
      state.integrationDetail = action.payload;
    },
    setIntegrationDetailLoading: (state, action: PayloadAction<boolean>) => {
      state.status.integrationDetailLoading = action.payload;
    },
    setCreateIntegrationLoading: (state, action: PayloadAction<boolean>) => {
      state.status.createIntegrationLoading = action.payload;
    },
    setUpdateIntegrationLoading: (state, action: PayloadAction<boolean>) => {
      state.status.updateIntegrationLoading = action.payload;
    },
  },
});

export const technologySettingsTechnologiesSliceReducer =
  technologySettingsTechnologiesSlice.reducer;
export const technologySettingsTechnologiesSliceAction =
  technologySettingsTechnologiesSlice.actions;
